import CryptoJS from "crypto-js";

// 判断是否微信环境
export const isWeixin = () => {
  if (
    navigator &&
    navigator.userAgent &&
    navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1
  ) {
    return true;
  }
  return false;
};

export const isAlipayEnvironment = () => {
  const userAgent = window.navigator.userAgent.toLowerCase();
  return /alipayclient/i.test(userAgent);
}

const appNames = {
  // 秋末
  "qiumo.net.cn": "huanxinxiang",
  // 海络
  "hzhlxx.net.cn": "huanxinxiang-hailuo",
  // 铮行
  "zjzxkj.net.cn": "huanxinxiang-zhengxing",
  // 秋末
  "szyxb299.xwtec.cn": "huanxinxiang",
  // 海络
  "szyxb311.xwtec.cn": "huanxinxiang-hailuo",
  // 云先
  "h5.aliyunxian.com.cn": "huanxinxiang-yunxian"
};

// 设置主体
export const setAppName = () => {
  const hostname = window.location.hostname;
  for (let domain in appNames) {
    if (hostname.includes(domain)) {
      return appNames[domain];
    }
  }
  return "";
};


// 观正签名
export const generateSign = (appCode ="GUANZHENG", appKey= "*OF*&(BNHOP0" ) => {
  const nowDate = new Date();
  const timesap = nowDate.getTime();

  const authData = appCode + appKey + timesap;
  // 使用CryptoJS.MD5生成MD5哈希
  let sign = CryptoJS.MD5(authData).toString(CryptoJS.enc.Hex);
  // 转换为大写
  sign = sign.toUpperCase();
  return {
    sign,
    timesap,
    appCode,
  };
};


// 流量果
import llgSDK from "@/utils/liuliangguoSDK_min";
/*
广告位名称：ad_position_id
phone：手机号
product_name： 原投放的产品名称
fail_message: 失败原因
*/
export const liuliangguo = (
  ad_position_id = "102265",
  phone = "",
  product_name = "原投放的产品名称",
  fail_message = "用户办理原产品的失败原因"
) => {
  console.log(ad_position_id);
  let params = {
    app_key: "LLG10005574",
    app_secret: "8a6f7c3f39e9ee88127d96b354b63c55",
    ad_position_id,
    phone,
    fail_message,
    product_name,
  };

  llgSDK.getAdAndShow(params, function (res) {
    console.log(res);
  });
};